<template>

    <p v-if="rendered_address" class="mb-8 text-sm font-medium">{{ rendered_address }}</p>

    <Button :onClick="() => state.modal_active = true" type="button" color="blue-100" width="w-auto">{{ state.locations.length === 0 ? 'Add address' : 'Edit address' }}</Button>
    <Button v-if="rendered_address" :onClick="() => resetState()" type="button" color="red" width="w-auto" class="ml-2">Remove address</Button>

    <Modal :active="state.modal_active" size="md">
        <div class="mb-12">
            <div class="mt-3 text-center sm:mt-5">
                <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900">Add an Address</DialogTitle>
                <div class="mt-8 text-left">
                    <FormField v-for="(field, key) in form.location.fields" :key="key" :field="field" namespace="add_location" :name="key" class="mb-4" />
                </div>
            </div>
        </div>
        <div class="">
            <Button :onClick="addLocation" type="button" color="blue" class="mb-2" :disabled="state.locations > 1">{{ state.locations.length === 0 ? 'Add' : 'Update' }}</Button>
            <Button v-if="true" type="button" color="text-blue" v-on:click="state.modal_active = false">Cancel</Button>
        </div>
    </Modal>
</template>

<script>
import { reactive, watch, computed } from 'vue'
import { DialogTitle } from '@headlessui/vue'
import { useSystemStore } from '@sto/system.store'
import TrashIconFill from "@ico/TrashIconFill.vue";
import { isValid } from "@lib/helpers";

export default {
    components: {
        TrashIconFill,
        DialogTitle
    },
    setup(props, {emit}) {

        const SYSTEM_STORE = useSystemStore()

        const state = reactive({
            modal_active: false,
            locations: []
        })

        const form = {
            location: {
                fields: {
                    address_line_1: {
                        active: true,
                        label: 'Address line 1',
                        type: 'text',
                        value: '',
                        placeholder: '',
                        stored_value: '',
                        required: true,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    address_line_2: {
                        active: true,
                        label: 'Address line 2',
                        type: 'text',
                        value: '',
                        placeholder: 'Optional',
                        stored_value: '',
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    address_line_3: {
                        active: true,
                        label: 'Address line 3',
                        type: 'text',
                        value: '',
                        placeholder: 'Optional',
                        stored_value: '',
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    town: {
                        active: true,
                        label: 'Town',
                        type: 'text',
                        value: '',
                        placeholder: '',
                        stored_value: '',
                        required: true,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    county: {
                        active: true,
                        label: 'County',
                        type: 'text',
                        value: '',
                        placeholder: '',
                        stored_value: '',
                        required: true,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    postcode: {
                        active: true,
                        label: 'Postcode',
                        type: 'text',
                        value: '',
                        placeholder: '',
                        stored_value: '',
                        required: true,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    }
                }
            }
        }

        const closeModal = () => {
            state.modal_active = false
        }

        const resetState = () => {
            for (let field in form.location.fields) {
                form.location.fields[field].value = ""
            }
            state.locations = []
        }

        // template for a location
        function Location(address_line_1 = '', address_line_2 = '', address_line_3 = '', town = '', county = '', postcode = '') {
            this.address_line_1 = address_line_1
            this.address_line_2 = address_line_2
            this.address_line_3 = address_line_3
            this.town = town
            this.county = county
            this.postcode = postcode
            this.temp_id = Date.now()
        }

        const addLocation = () => {

            if (!isValid(form.location.fields)) {
                return SYSTEM_STORE.addError('Missing Information', 'Some fields are missing or invalid')
            }

            state.locations = []

            state.locations.push(new Location(
                form.location.fields.address_line_1.value,
                form.location.fields.address_line_2.value,
                form.location.fields.address_line_3.value,
                form.location.fields.town.value,
                form.location.fields.county.value,
                form.location.fields.postcode.value
            ))
            SYSTEM_STORE.addSuccess('Address added')
            //resetState()
            closeModal()
        }

        const removeLocation = temp_id => {
            state.locations = state.locations.filter(a => a.temp_id != temp_id)
            SYSTEM_STORE.addSuccess('Address removed')
        }

        const rendered_address = computed(() => {

            if (!state.locations.length) return null

            let address_obj = state.locations[0]
            let address_full = ''

            if (address_obj.address_line_1) address_full += address_obj.address_line_1
            if (address_obj.address_line_2) address_full += (address_full.length > 0 ? ', ' : ' ') + address_obj.address_line_2
            if (address_obj.address_line_3) address_full += (address_full.length > 0 ? ', ' : ' ') + address_obj.address_line_3
            if (address_obj.town) address_full += (address_full.length > 0 ? ', ' : ' ') + address_obj.town
            if (address_obj.county) address_full += (address_full.length > 0 ? ', ' : ' ') + address_obj.county
            if (address_obj.postcode) address_full += (address_full.length > 0 ? ', ' : ' ') + address_obj.postcode

            return address_full
        })

        watch(
            () => state.modal_active,
            () => {
                //resetState()
            }
        )

        watch(
            () => state.locations.length,
            (new_value) => {
                if (!Array.isArray(state.locations) || state.locations.length === 0) return emit('value_update', '')

                // all this fuss is necessary
                let locations_temp = JSON.stringify(state.locations)
                locations_temp = JSON.parse(locations_temp)
                locations_temp.forEach(location => {
                    delete location.temp_id
                })
                emit('value_update', JSON.stringify(locations_temp))
            }
        )

        return {
            state,
            form,
            rendered_address,
            addLocation,
            removeLocation,
            resetState
        }
    }
}
</script>